<template>
  <div style="display: inline">
    <b-notification
      v-show="!isTag && displayWarning"
      :closable="false"
      type="is-danger is-light"
    >
      <span v-html="$t('compCarbonFormsPurchasesWarning.message-1')" />
      {{ TRAVELLING_EXPENSES_CODES.map((val) => val.toUpperCase()).join(', ')
      }}<span v-html="$t('compCarbonFormsPurchasesWarning.message-2')" />
      <b> {{ WARNING_RATE }}% </b>
      <span v-html="$t('compCarbonFormsPurchasesWarning.message-3')" />,
      {{ purchasesEmissions | splitNumberTons }} {{ $t('t.co2e') }}
      {{ $t('compCarbonFormsPurchasesWarning.message-6') }}
      {{ travelsEmissions | splitNumberTons }} {{ $t('t.co2e') }}.
      <br />
      <span v-html="$t('compCarbonFormsPurchasesWarning.message-4')" />
      {{
        TRAVELLING_EXPENSES_CODES.map((val) => val.toUpperCase()).join(', ')
      }}. <span v-html="$t('compCarbonFormsPurchasesWarning.message-5')" />
    </b-notification>
    <div v-if="!isTag && displayWarning" />
    <b-tooltip
      v-show="isTag && displayWarning"
      size="is-large"
      type="is-danger is-light"
      multilined
    >
      <template v-slot:content>
        <span v-html="$t('compCarbonFormsPurchasesWarning.message-1')" />
        {{ TRAVELLING_EXPENSES_CODES.map((val) => val.toUpperCase()).join(', ')
        }}<span v-html="$t('compCarbonFormsPurchasesWarning.message-2')" />
        <b> {{ WARNING_RATE }}% </b>
        <span v-html="$t('compCarbonFormsPurchasesWarning.message-3')" />,
        {{ purchasesEmissions | splitNumberTons }} {{ $t('t.co2e') }}
        {{ $t('compCarbonFormsPurchasesWarning.message-6') }}
        {{ travelsEmissions | splitNumberTons }} {{ $t('t.co2e') }}.
        <br />
        <span v-html="$t('compCarbonFormsPurchasesWarning.message-4')" />
        {{
          TRAVELLING_EXPENSES_CODES.map((val) => val.toUpperCase()).join(', ')
        }}. <span v-html="$t('compCarbonFormsPurchasesWarning.message-5')" />
      </template>
      <b-tag type="is-danger">
        {{ $t('compCarbonFormsPurchasesWarning.message-7') }} </b-tag
      >&nbsp;&nbsp;
    </b-tooltip>
  </div>
</template>

<script>
import Purchase from '@/models/carbon/Purchase.js'
import { useGHGIStore } from '@/stores/ghgi.js'

export default {
  name: 'Warning',
  props: {
    isTag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      TRAVELLING_EXPENSES_CODES: Purchase.getTravellingExpensesCodes(),
      WARNING_RATE: Purchase.getWarningRate(),
      travelsEmissions: 0,
      purchasesEmissions: 0
    }
  },
  setup () {
    const ghgiStore = useGHGIStore()
    return { ghgiStore }
  },
  computed: {
    ghgi: function () {
      return this.ghgiStore.item
    },
    displayWarning: function () {
      if (this.purchasesEmissions !== 0 && this.travelsEmissions !== 0) {
        return (
          (this.purchasesEmissions * 100) / this.travelsEmissions >=
          this.WARNING_RATE
        )
      } else {
        return false
      }
    }
  },
  methods: {
    forceComputation: function () {
      this.ghgiStore.compute([])
      this.travelsEmissions = this.ghgi.emissions.travels.intensity.intensity
      this.purchasesEmissions = this.ghgi.emissions.purchases.totalXA
    }
  }
}
</script>

<style>
.notification.is-danger.is-light {
  background-color: #feecf0 !important;
  color: #cc0f35 !important;
}
.b-tooltip.is-multiline.is-large .tooltip-content {
  width: 500px !important;
}
.b-tooltip.is-light .tooltip-content {
  background-color: #feecf0 !important;
  color: #cc0f35 !important;
  box-shadow: 0 1px 2px 1px #feecf0;
}
</style>
